import './App.css';
import Board from './Components/Board';
import Header from './Components/Header';

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Board></Board>
    </div>
  );
}

export default App;
